import { withCompInfo } from '@wix/editor-elements-integrations'
import type { MultiStateBoxDefinition } from './MultiStateBox'
import _ from 'lodash'

export const props = withCompInfo<any, MultiStateBoxDefinition>()(
	// @ts-ignore
	['compData', 'responsiveContainerProps', 'containerRootClassName', 'isRepeaterChild'],
	// @ts-ignore
	({ compData, responsiveContainerProps, containerRootClassName, isRepeaterChild }) => {
		const { selectedStateId } = compData as any
		const role = isRepeaterChild ? 'listitem' : ''
		return _.omitBy(
			{
				containerProps: responsiveContainerProps,
				containerRootClassName,
				role,
				selectedStateId,
			},
			(value) => _.isNil(value) || _.isEmpty(value)
		)
	}
)
